import React from 'react'
import { string, fphoto } from '../../helper/common'
import { MaleUrl } from '../../config/const'
import strings from '../../lang/strings'
import Styles from './rank.module.css'
export default function RankDashboard(props) {
    const { title, items, onClick } = props
    return (
        <div className={`${Styles.rankingTable} fs-24 sm-fs-20 f-b`}>
        <div className='mb-8'>{title}</div>
            {items.map(function (item, idx) {
                return (
                    idx == 0 ?
                        (
                            <div key={idx} className={`fs-20 sm-fs-16 ${Styles.firstRankWrap}`} onClick={() => onClick(item)}>
                                <div className={`mb-16 ${Styles.firstRankTitle}`}>
                                    <img className={Styles.badge} src={'/assets/image/badge.png'} alt={''} />
                                    <span style={{"whiteSpace": "pre-line"}}>{string.Format(strings.top_member, 1, item.mb_nick)}</span>
                                </div>
                                <div className={`${Styles.fistRankProfile}`}>
                                    <img src={fphoto(item.mb_photo, 'member', MaleUrl)} alt={''} />
                                </div>
                            </div>
                        ) :
                        (
                            <div key={idx} className={`fs-20 sm-fs-16 ${Styles.clickable} ${Styles.itemContainer} ${Styles.rankProfile}`} onClick={() => onClick(item)}>
                                <div className='fs-24 ml-16 mr-16'> {idx + 1}</div>
                                <img className='mr-16' src={fphoto(item.mb_photo, 'member', MaleUrl)} alt={''} />
                                <div>{item.mb_nick}</div>
                            </div>
                        )

                )
            })}
        </div >
    )
}